// Lightweight API helpers for the NoEffortsAi iDE backend.
// All requests use REACT_APP_BACKEND_URL with the /api prefix.

export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL ||
  (typeof window !== "undefined" ? window.location.origin : "");

function url(path) {
  return `${BACKEND_URL}${path}`;
}

async function jsonOrThrow(res) {
  let body = null;
  try { body = await res.json(); } catch (_) { /* ignore */ }
  if (!res.ok) {
    const err = new Error(
      (body && (body.detail?.error || body.detail || body.error)) ||
      `HTTP ${res.status}`
    );
    err.status = res.status;
    err.body = body;
    throw err;
  }
  return body;
}

export async function fetchLanguages() {
  const res = await fetch(url("/api/languages"));
  return jsonOrThrow(res);
}

export async function fetchHealth() {
  const res = await fetch(url("/api/health"));
  return jsonOrThrow(res);
}

export async function runSync({ language, code, stdin, timeout = 10, signal }) {
  const res = await fetch(url("/api/run"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ language, code, stdin, timeout }),
    signal,
  });
  return jsonOrThrow(res);
}

export async function runWeb({ html, css, js }) {
  const res = await fetch(url("/api/run-web"), {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ html, css, js }),
  });
  return jsonOrThrow(res);
}

export async function stopRun(runId) {
  const res = await fetch(url(`/api/stop/${encodeURIComponent(runId)}`), {
    method: "POST",
  });
  return jsonOrThrow(res);
}

export function buildPreviewURL(previewUrl) {
  if (!previewUrl) return "";
  if (previewUrl.startsWith("http")) return previewUrl;
  return `${BACKEND_URL}${previewUrl}`;
}

export function buildWsURL(path) {
  try {
    const u = new URL(BACKEND_URL);
    const proto = u.protocol === "https:" ? "wss:" : "ws:";
    return `${proto}//${u.host}${path}`;
  } catch (_) {
    const proto =
      typeof window !== "undefined" && window.location.protocol === "https:"
        ? "wss:"
        : "ws:";
    const host = typeof window !== "undefined" ? window.location.host : "";
    return `${proto}//${host}${path}`;
  }
}
